export const PREFIX = 'skapa-mvagent-wrapper-prefix-';
